<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>
    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span
            ><em name="Exhibition"></em><span>/</span
            ><span class="px-0">大會活動</span><span>/</span
            ><span
              @click.prevent="toEventMain"
              style="color: #1a73e8"
              class="pointer px-0"
              >test</span
            ><span>/</span><a href="javascript:history.back()">選擇推廣產品</a
            ><span>/</span>建立推廣產品介紹
          </div>
          <div>
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="contentBox">
          <div class="container">
            <h1>新增線上活動贈品贊助</h1>
            <p class="my-3">&nbsp;</p>
            <p class="alert">
              <i class="fas fa-exclamation-circle"></i>
              請勿上傳與本展無關或是妨害社會善良風俗之內容，主辦單位有權刪除不適當的內容。
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="AddPromotionPro">
              <input type="hidden" name="RegNo" />

              <p class="formTitle">活動名稱</p>
              <p>
                {{ EventDetail.EventName }}
              </p>

              <p class="my-4">&nbsp;</p>

              <div class="my-4">
                <p class="formTitle">產品圖片</p>
                <div class="card mb-3">
                  <div class="card-body py-2 px-4">
                    <div
                      class="row d-none d-md-flex py-1 border-bottom mb-2 text-secondary bold"
                      style="font-size: 0.85rem"
                    >
                      <div class="col-md-3">預覽圖</div>
                      <div class="col-md-6">規格要求</div>
                      <div class="col-md-3 text-center">操作</div>
                    </div>

                    <div class="row align-items-center pb-2">
                      <div class="col-md-3 col-12 mb-2 mb-md-0">
                        <div
                          class="border rounded bg-light d-flex align-items-center justify-content-center mx-auto mx-md-0"
                          style="
                            width: 80px;
                            height: 80px;
                            overflow: hidden;
                            max-width: 50%;
                          "
                        >
                          <img
                            v-if="hasImgfile"
                            :src="modelSrc"
                            class="img-fluid"
                            style="object-fit: cover; width: 100%; height: 100%"
                          />
                          <img
                            v-else
                            src="../../../assets/images/default.jpg"
                            class="img-fluid"
                            style="object-fit: cover; width: 100%; height: 100%"
                          />
                        </div>
                      </div>

                      <div class="col-md-6 col-12 mb-2 mb-md-0">
                        <div
                          class="text-secondary d-flex flex-wrap justify-content-center justify-content-md-start"
                          style="font-size: 0.8rem"
                        >
                          <span class="mr-3"
                            ><i class="fas fa-info-circle mr-1"></i>小於
                            3MB</span
                          >
                          <span class="mr-3"
                            ><i class="fas fa-file-image mr-1"></i>JPG,
                            WEBP</span
                          >
                          <span
                            ><i class="fas fa-expand mr-1"></i>500x500+ px</span
                          >
                        </div>
                      </div>

                      <div class="col-md-3 col-12">
                        <div class="d-flex justify-content-center">
                          <label
                            class="btn btn-sm btn-outline-primary mb-0 mr-2 cursor-pointer px-3"
                          >
                            <i class="fas fa-upload"></i> 選擇圖片
                            <input
                              type="file"
                              accept=".jpg,.jpeg,.webp"
                              class="d-none"
                              @change="uploadImgPC($event, 'product')"
                            />
                          </label>
                          <button
                            v-if="modelSrc !== noImageSrc"
                            class="btn btn-sm btn-link text-danger p-0"
                            title="重設"
                            @click.prevent="resetImg"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p class="my-4">&nbsp;</p>

              <div class="left">
                <p class="formTitle">產品名稱 <span class="red">*</span></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="ProName"
                    class="textStyle maxText"
                    maxlength="200"
                    required
                    placeholder="請輸入產品名稱"
                    v-model="ProName"
                  />
                  <span>中</span>
                </div>
              </div>

              <div class="right">
                <p class="formTitle">產品類別 <span class="red">*</span></p>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <select
                      class="form-control text-dark"
                      v-model="CatID"
                      required
                      style="height: 45px"
                    >
                      <option value="">-- 請選擇 --</option>
                      <option
                        v-for="item in EventsCategories"
                        :value="item.CatID"
                        :key="item.CatID"
                      >
                        {{ item.CatName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>

              <div class="left">
                <p class="formTitle">產品簡介 <span class="red">*</span></p>

                <textarea
                  name="ProDesc"
                  rows="3"
                  class="maxText textStyle"
                  maxlength="500"
                  placeholder="請輸入500字內的產品介紹"
                  v-model="ProDesc"
                ></textarea>
              </div>

              <div class="right">
                <p class="formTitle">規格 <span class="red">*</span></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="ProSpec"
                    class="textStyle maxText"
                    maxlength="200"
                    required
                    placeholder="中文"
                    v-model="ProSpec"
                  />
                  <span>中</span>
                </div>
              </div>
              <p class="clear"></p>

              <p class="my-3">&nbsp;</p>

              <div class="left">
                <p class="formTitle">提供數量</p>
                <div>
                  <input
                    type="number"
                    name="ProvidedCount"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="ProvidedCount"
                  />
                </div>
              </div>

              <div class="right">
                <p class="formTitle">市價(NT$)</p>
                <div>
                  <input
                    type="text"
                    name="ProPrice"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="ProPrice"
                  />
                </div>
              </div>
              <p class="clear"></p>

              <p class="my-3">&nbsp;</p>

              <div class="my-4">
                <p class="formTitle">贊助商 Logo</p>
                <div class="card mb-3">
                  <div class="card-body py-2 px-4">
                    <div
                      class="row d-none d-md-flex py-1 border-bottom mb-2 text-secondary bold"
                      style="font-size: 0.85rem"
                    >
                      <div class="col-md-3">預覽圖</div>
                      <div class="col-md-6">規格要求</div>
                      <div class="col-md-3 text-center">操作</div>
                    </div>

                    <div class="row align-items-center pb-2">
                      <div class="col-md-3 col-12 mb-2 mb-md-0">
                        <div
                          class="border rounded bg-light d-flex align-items-center justify-content-center mx-auto mx-md-0"
                          style="
                            width: 80px;
                            height: 80px;
                            overflow: hidden;
                            max-width: 50%;
                          "
                        >
                          <img
                            v-if="hasLogofile"
                            :src="logoSrc"
                            class="img-fluid"
                            style="object-fit: cover; width: 100%; height: 100%"
                          />
                          <img
                            v-else
                            src="../../../assets/images/default.jpg"
                            class="img-fluid"
                            style="object-fit: cover; width: 100%; height: 100%"
                          />
                        </div>
                      </div>

                      <div class="col-md-6 col-12 mb-2 mb-md-0">
                        <div
                          class="text-secondary d-flex flex-wrap justify-content-center justify-content-md-start"
                          style="font-size: 0.8rem"
                        >
                          <span class="mr-3"
                            ><i class="fas fa-info-circle mr-1"></i>小於
                            3MB</span
                          >
                          <span class="mr-3"
                            ><i class="fas fa-file-image mr-1"></i>PNG, JPG
                            (建議去背)</span
                          >
                          <span
                            ><i class="fas fa-expand mr-1"></i>建議 400x400
                            px</span
                          >
                        </div>
                      </div>

                      <div class="col-md-3 col-12">
                        <div class="d-flex justify-content-center">
                          <label
                            class="btn btn-sm btn-outline-primary mb-0 mr-2 cursor-pointer px-3"
                          >
                            <i class="fas fa-upload"></i> 選擇圖片
                            <input
                              type="file"
                              accept=".jpg,.jpeg,.webp,.png"
                              class="d-none"
                              @change="uploadImgPC($event, 'logo')"
                            />
                          </label>
                          <button
                            v-if="logoSrc !== noImageSrc"
                            class="btn btn-sm btn-link text-danger p-0"
                            title="重設"
                            @click.prevent="resetLogo"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="my-4">&nbsp;</p>

              <div class="left">
                <p class="formTitle">現場聯絡人姓名</p>
                <div>
                  <input
                    type="text"
                    name="ContactName"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="ContactName"
                  />
                </div>
              </div>

              <div class="right">
                <p class="formTitle">現場聯絡人手機</p>
                <div>
                  <input
                    type="text"
                    name="ContactMobile"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="ContactMobile"
                  />
                </div>
              </div>
              <p class="clear"></p>

              <p class="my-3">&nbsp;</p>

              <div class="left">
                <p class="formTitle">產品網站連結</p>
                <div>
                  <input
                    type="text"
                    name="ProUrl"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="ProUrl"
                  />
                </div>
              </div>

              <div class="right">
                <p class="formTitle">Facebook連結</p>
                <div>
                  <input
                    type="text"
                    name="FbUrl"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="FbUrl"
                  />
                </div>
              </div>
              <p class="clear"></p>

              <p class="my-3">&nbsp;</p>

              <div class="left">
                <p class="formTitle">Instagram連結</p>
                <div>
                  <input
                    type="text"
                    name="IgUrl"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="IgUrl"
                  />
                </div>
              </div>

              <div class="right">
                <p class="formTitle">其他社群連結</p>
                <div>
                  <input
                    type="text"
                    name="OtherSocialUrl"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="OtherSocialUrl"
                  />
                </div>
              </div>

              <p class="clear"></p>

              <p class="my-3">&nbsp;</p>
              <p class="formTitle">
                宣傳貼文文案 (中) <span class="red">*</span>
              </p>
              <textarea
                name="PromoPostText"
                rows="6"
                class="maxText textStyle"
                placeholder="中文"
                v-model="PromoPostText"
                required
              ></textarea>

              <p class="my-3">&nbsp;</p>

              <!-- <div v-if="inputDescHidden == 0">
                <p class="formTitle mt-2">
                  {{ inputDescName }}
                  <span class="red" v-if="inputDescRequired == 0">*</span>
                </p>
                <div v-if="LocalExh">
                  <div class="langTip">
                    <input
                      type="text"
                      name="Desc"
                      class="maxText textStyle"
                      :required="inputDescRequired == 0"
                      maxlength="20"
                      v-model="reg_Desc"
                    />
                    <span>中 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="inputDescNotes">
                    {{ inputDescNotes }}
                  </div>
                </div>
                <div v-if="einputDescName">
                  <div class="langTip mt-2">
                    <input
                      type="text"
                      name="Desc"
                      class="maxText textStyle"
                      :required="inputDescRequired == 0"
                      maxlength="50"
                      v-model="ereg_Desc"
                    />
                    <span>英 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="einputDescNotes">
                    {{ einputDescNotes }}
                  </div>
                </div>

                <p class="my-3">&nbsp;</p>
              </div>

              <div class="mt-3" v-if="inputDescHidden2 == 0">
                <p class="formTitle">
                  {{ inputDescName2 }}
                  <span class="red" v-if="inputDescRequired2 == 0">*</span>
                </p>
                <div v-if="LocalExh">
                  <div class="langTip">
                    <input
                      type="text"
                      name="Desc2"
                      class="maxText textStyle"
                      :required="inputDescRequired2 == 0"
                      maxlength="20"
                      v-model="reg_Desc2"
                    />
                    <span>中 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="inputDescNotes2">
                    {{ inputDescNotes2 }}
                  </div>
                </div>
                <div v-if="einputDescName">
                  <div class="langTip mt-2">
                    <input
                      type="text"
                      name="Desc2"
                      class="maxText textStyle"
                      :required="inputDescRequired2 == 0"
                      maxlength="50"
                      v-model="ereg_Desc2"
                    />
                    <span>英 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="einputDescNotes2">
                    {{ einputDescNotes2 }}
                  </div>
                </div>

                <p class="my-3">&nbsp;</p>
              </div>

              <span v-if="inputOnlineDateHidden == 0">
                <p class="formTitle mt-3">
                  上市時間
                  <span class="red" v-if="inputOnlineDateRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="LaunchDate"
                    class="maxText textStyle"
                    :required="inputOnlineDateRequired == 0"
                    maxlength="20"
                    v-model="reg_LaunchDate"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputPriceHidden == 0">
                <p class="formTitle">
                  市價(NT$)
                  <span class="red" v-if="inputPriceRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="Price"
                    class="maxText textStyle"
                    :required="inputPriceRequired == 0"
                    maxlength="20"
                    v-model="reg_Price"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputDiscountPriceHidden == 0">
                <p class="formTitle">
                  展場限定價(NT$)
                  <span class="red" v-if="inputDiscountPriceRequired == 0"
                    >*</span
                  >
                </p>
                <div>
                  <input
                    type="text"
                    name="Discount"
                    class="maxText textStyle"
                    :required="inputDiscountPriceRequired == 0"
                    maxlength="20"
                    v-model="reg_DiscountPrice"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span> -->
              <div class="d-flex justify-content-center">
                <input type="submit" value="確定送出" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="backSelectPro">
                  返回
                </div>
              </div>
            </form>
          </div>
        </div>
      </article>
    </div>

    <!-- 桌機板裁切工具 Modal  -->
    <div id="cropImagePop" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between">
            <div class="modal-title" style="font-size: 25px">
              <div class="d-flex align-self-center">
                <div class="mr-3">
                  <img src="../../../assets/images/cropImg.png" width="30px" />
                </div>
                <div style="font-size: 25px">編輯產品圖片</div>
              </div>
            </div>
            <div
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-8">
                <div class="CropBoxStyle">
                  <vue-cropper
                    ref="cropper"
                    :img="option.img"
                    :output-size="option.size"
                    :output-type="option.outputType"
                    :info="true"
                    :full="option.full"
                    :fixed="fixed"
                    :can-move="option.canMove"
                    :can-move-box="option.canMoveBox"
                    :fixed-box="option.fixedBox"
                    :original="option.original"
                    :auto-crop="option.autoCrop"
                    :auto-crop-width="option.autoCropWidth"
                    :auto-crop-height="option.autoCropHeight"
                    :center-box="option.centerBox"
                    :high="option.high"
                    :max-img-size="option.max"
                    :fixed-number="fixedNumber"
                    :enlarge="option.enlarge"
                    :infoTrue="option.infoTrue"
                    :mode="option.mode"
                    @real-time="realTime"
                  >
                  </vue-cropper>
                </div>

                <div class="d-flex justify-content-between mt-3 mx-3">
                  <div>
                    <button @click="rotateLeft" class="btn btn-info">
                      向左旋轉
                    </button>
                    <button @click="rotateRight" class="btn btn-info ml-2">
                      向右旋轉
                    </button>
                    <button @click="changeScale(1)" class="btn btn-info ml-2">
                      放大
                    </button>
                    <button @click="changeScale(-1)" class="btn btn-info ml-2">
                      縮小
                    </button>
                  </div>
                  <div>
                    <button
                      @click="refreshCrop"
                      class="btn btn-outline-info ml-5"
                    >
                      重設
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div :style="previewStyle1" class="ImgPreCrop">
                  <div :style="previews.div">
                    <img :src="previews.url" :style="previews.img" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr />
          <div class="modal-footer">
            <div>
              <button
                type="button"
                id="cropImageBtn"
                class="btn btn-primary btn-lg mr-2"
                @click="OutputPC()"
              >
                裁切
              </button>
              <button
                type="button"
                class="btn btn-lg btn-secondary"
                data-dismiss="modal"
              >
                關閉
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 行動版裁切工具 Modal  -->
    <div
      class="modal fade"
      id="cropperMb"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p>&middot; 系統將自動調整圖片至正方形尺寸。</p>
            <p>&middot; 如有裁切及編輯圖片之需求，請至 PC 裝置上傳圖片。</p>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              id="cropperMb"
              class="btn btn-sm btn-primary"
              @click="OutputMb()"
            >
              確定
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "建立推廣產品介紹 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      LocalExh: true,
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      lang: "tw",
      EventDetail: {},
      MarketingRegisterList: [],
      ProductID: "",
      ProductDetail: {},
      reg_Desc: "",
      reg_Desc2: "",
      ereg_Desc: "",
      ereg_Desc2: "",
      reg_LaunchDate: "",
      reg_Price: "",
      reg_DiscountPrice: "",
      EventCatList: [],
      CatID: "",
      eventId: "",
      inputDescHidden: "",
      inputOnlineDateHidden: "",
      inputPriceHidden: "",
      inputDiscountPriceHidden: "",
      inputDescName: "",
      EventName: "",

      einputDescName: "",
      einputDescName2: "",
      einputDescNotes: "",
      einputDescNotes2: "",

      inputDescRequired: "",
      inputDescNotes: "",
      inputDescName2: "",
      inputDescHidden2: "",
      inputDescRequired2: "",
      inputDescNotes2: "",
      inputOnlineDateRequired: "",
      inputPriceRequired: "",
      inputDiscountPriceRequired: "",
      EventsCategories: [],
      ProvidedCount: 0,
      ProName: "",
      ProDesc: "",
      ProSpec: "",
      ProPrice: "",
      ContactName: "",
      ContactMobile: "",
      ProUrl: "",
      PromoPostText: "",
      eventType: "",
      OtherSocialUrl: "",
      FbUrl: "",
      IgUrl: "",
      modelSrc: "../../../assets/images/default.jpg",
      noImageSrc: "../../../assets/images/default.jpg",
      modelEnSrc: "../../../assets/images/default.jpg",
      noImageEnSrc: "../../../assets/images/default.jpg",
      hasImgfile: false,

      previews: {},
      previewStyle1: {},
      lang: "tw",

      option: {
        img: "", // 裁剪图片的地址V
        max: 9999, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: "contain",

        centerBox: false, // 截图框是否被限制在图片里面
        canMove: true, //上传图片是否可以移动
        infoTrue: true,

        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false, // 截图框能否拖动
        autoCrop: true, // 是否默认生成截图框
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 500,

        full: false, //是否输出原图比例的截图，X匯出等比例(長型就匯長型)
        high: false, //是否按照设备的dpr 输出等比例图片，X匯出等比例(長型就匯長型)
        original: false, // 上传图片按照原始比例渲染

        size: 0.7, //裁剪生成图片的质量V
        outputType: "png", // 裁剪生成图片的格式V
      },

      fixed: true, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例

      hasImgfile: false,

      logoSrc: "../../../assets/images/default.jpg",
      hasLogofile: false,
      currentUploadType: "product",
    };
  },

  watch: {},

  methods: {
    toEventMain() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
    },
    AddPromotionPro() {
      const vm = this;
      const url = "/apiExhibitors/MarketingEventRegister/";

      const info = {
        regNo: vm.RegNo,
        eventId: vm.eventId,
        proNo: vm.ProductID,
        CatID: vm.CatID,
        reg_Desc: vm.reg_Desc,
        reg_Desc2: vm.reg_Desc2,
        ereg_Desc: vm.ereg_Desc,
        ereg_Desc2: vm.ereg_Desc2,

        reg_LaunchDate: vm.reg_LaunchDate,
        reg_Price: vm.reg_Price,
        reg_DiscountPrice: vm.reg_DiscountPrice,
        CSRF: vm.CSRF_Token,
      };

      // console.log(info)

      axios.post(url, info).then(function (response) {
        if (response.data.Code == 200) {
          alert("您已成功上傳！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 500) {
          alert("系統忙碌，請稍後再試！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 252) {
          document.location.href = `https://www.chanchao.com.tw/`;
        } else if (response.data.Code == 253) {
          alert("報名活動與報名表序號的參展代碼不一致！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (response.data.Code == 254) {
          alert("報名表序號與報名產品為不同參展商！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (response.data.Code == 255) {
          alert("報名時間超過活動的參展商系統上下線時間！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (response.data.Code == 256) {
          alert("廠商報名表的報名攤位數小於活動的限制攤位數！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (response.data.Code == 257) {
          alert("廠商已報名數量大於活動的限制報名數量！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (response.data.Code == 258) {
          alert("選取之產品已報名過活動！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        }
      });
    },

    backSelectPro() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}`;
    },

    OpenCategoryModal() {
      $("#SearchModal").modal("show");
    },
    uploadImgPC(e, type = "product") {
      // 增加 type 參數
      const vm = this;
      vm.currentUploadType = type; // 紀錄現在是誰在動

      var file = e.target.files[0];
      if (!/\.(jpg|jpeg|JPG|JPEG|webp|WEBP)$/.test(e.target.value)) {
        alert("上傳檔案類型必須是 JPG 或 WebP！");
        return false;
      }

      var reader = new FileReader();
      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;
        if (isLt5M) {
          $("#cropImagePop").modal("show");
          $("#cropImagePop").on("shown.bs.modal", function () {
            vm.option.img = window.URL.createObjectURL(
              new Blob([e.target.result]),
            );
          });
        } else {
          alert("上傳圖片大小請勿超過 3MB！");
        }
      };
      reader.readAsArrayBuffer(file);
      e.target.value = "";
    },

    uploadImgMb(e, type = "product") {
      // 補上 type
      const vm = this;
      vm.currentUploadType = type; // 紀錄現在是誰在動

      var file = e.target.files[0];
      // ...中間檢查碼不變...

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;
        if (isLt5M) {
          this.option.img = window.URL.createObjectURL(
            new Blob([e.target.result]),
          );
          vm.showImg = true;
          $("#cropperMb").modal("show");
        } else {
          alert("Maximum file size : 3MB");
        }
      };
      // ...
    },

    OutputPC() {
      const vm = this;
      this.$refs.cropper.getCropData((data) => {
        // 根據標記判斷要更新哪個欄位
        if (vm.currentUploadType === "product") {
          vm.modelSrc = data;
          vm.hasImgfile = true;
        } else if (vm.currentUploadType === "logo") {
          vm.logoSrc = data;
          vm.hasLogofile = true;
        }

        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.option.img = "/";
          // 清除事件監聽，避免重複觸發
          $(this).off("hidden.bs.modal");
        });

        $("#cropImagePop").modal("hide");

        // 提示訊息也可以根據類型微調
        const msg =
          vm.currentUploadType === "product"
            ? "產品圖片上傳成功"
            : "贊助商 Logo 上傳成功";
        window.setTimeout(() => alert(msg), 500);
      });
    },

    OutputEnPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelEnSrc = data;
        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.hasImgfile = true;
          vm.option.img = "/";
        });
        $("#cropImagePop").modal("hide");

        window.setTimeout(
          () =>
            alert(
              'The picture uploaded successfully. Please also fill out the product information required, and click "Submit" to complete the process.',
            ),
          1000,
        );
      });
    },

    OutputMb() {
      const vm = this;
      this.$refs.cropper.getCropData((data) => {
        // 根據標記判斷存到哪裡
        if (vm.currentUploadType === "product") {
          vm.modelSrc = data;
          vm.hasImgfile = true;
        } else if (vm.currentUploadType === "logo") {
          vm.logoSrc = data;
          vm.hasLogofile = true;
        }
      });
      $("#cropperMb").modal("hide");
      vm.showImg = false;
    },

    OutputEnMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelEnSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;
    },
    resetImg() {
      const vm = this;
      vm.modelSrc = "../../../assets/images/default.jpg";
      vm.hasImgfile = false;
    },
    // 实时预览函数
    realTime(data) {
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      this.previewStyle1 = {
        width: previews.w + "px",
        height: previews.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: h,
      };

      this.previews = data;
    },

    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },

    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },

    refreshCrop() {
      this.$refs.cropper.refresh();
    },

    resetLogo() {
      this.logoSrc = this.noImageSrc;
      this.hasLogofile = false;
    },
  },

  computed: {},

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    const urlParams = new URLSearchParams(window.location.search);

    vm.RegNo = urlParams.get("no");

    vm.eventId = urlParams.get("eventID") || urlParams.get("eventId");

    vm.eventType = urlParams.get("eventType");

    // --- 偵錯用，建議開發時留著 ---
    console.log("抓取參數結果:", {
      RegNo: vm.RegNo,
      eventId: vm.eventId,
      eventType: vm.eventType,
    });

    let url = `/apiExhibitors/Product/${vm.RegNo}/${vm.ProductID}`;
    axios.get(url).then(function (response) {
      // console.log(response.data.Data)
      vm.ProductDetail = response.data.Data;
    });

    // axios
    //   .get(
    //     `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
    //   )
    //   .then((response) => {
    //     let ExpoLocation = response.data.Data.ExpoLocation;

    //     if (ExpoLocation === "T" || ExpoLocation === null) {
    //       vm.LocalExh = true;
    //     } else {
    //       vm.LocalExh = false;
    //     }
    //   });

    //取得總資料
    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/MarketingEvents/Detail/${vm.eventId}?type=${vm.eventType}&lang=tw`,
      )
      .then((response) => {
        vm.EventDetail = response.data.Data;

        // 欄位顯示判定

        // 開啟時間判定
        // let OpenRegiterDate = response.data.Data.backEndStartDate;
        // let CloseRegiterDate = response.data.Data.backEndEndDate;
        // let Nowdate = Date.parse(new Date()).valueOf();

        // if (Nowdate < OpenRegiterDate) {
        //   alert("活動尚未開放");
        //   document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        // } else if (Nowdate > CloseRegiterDate) {
        //   alert("活動尚未開放");
        //   document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        // }
      });

    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/MarketingEvents/Categories/${vm.eventId}?type=${vm.eventType}&lang=tw`,
      )
      .then((response) => {
        vm.EventsCategories = response.data.Data;
      });
  },
};
</script>

<style lang="scss">
.modal-xl {
  max-width: 940px;
}

.proRight {
  border-left: 0px solid #dadce0;
}

.proLeft {
  padding-right: 0px;
}

.modal-body {
  height: 75vh;
  overflow-y: auto;
}

.el-collapse-item__header {
  font-size: 17px;
  font-weight: 550;

  height: 55px;
  line-height: 23px;
}
</style>
